"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Li = exports.liStyle = exports.OrderedList = exports.olStyle = exports.UnorderedList = exports.ulStyle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _mediaGenerator = _interopRequireDefault(require("@berlitz/max-utils/lib/mediaGenerator"));
var _globals = require("@berlitz/globals");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ulStyle = (0, _styledComponents.css)(["column-count:", ";column-gap:", ";", " padding-bottom:", ";", ";> li::before{content:'';display:inline-block;position:absolute;", " top:", ";background-color:", ";height:", ";width:", ";border-radius:50%;}"], function (props) {
  return props.cols;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.layout.lg;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: ", ";\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xl;
}), function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.lg;
}, function (_ref4) {
  var theme = _ref4.theme,
    collapse = _ref4.collapse;
  return (0, _mediaGenerator.default)(theme, collapse, 'column-count: 1;');
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      left: -", ";\n    "])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.lg;
}), function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.md;
}, function (_ref7) {
  var theme = _ref7.theme,
    inverse = _ref7.inverse;
  return theme.typography.li[!inverse ? 'bulletColor' : 'bulletColorInverse'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.li.bulletSize;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.li.bulletSize;
});
exports.ulStyle = ulStyle;
var UnorderedList = _styledComponents.default.ul.withConfig({
  displayName: "Liststyle__UnorderedList",
  componentId: "i5y035-0"
})(["", ";"], ulStyle);
exports.UnorderedList = UnorderedList;
var olStyle = (0, _styledComponents.css)(["list-style-type:decimal;column-count:", ";column-gap:", ";", " ", ";"], function (props) {
  return props.cols;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.layout.lg;
}, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: ", ";\n  "])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.xl;
}), function (_ref12) {
  var theme = _ref12.theme,
    collapse = _ref12.collapse;
  return (0, _mediaGenerator.default)(theme, collapse, 'column-count: 1;');
});
exports.olStyle = olStyle;
var OrderedList = _styledComponents.default.ol.withConfig({
  displayName: "Liststyle__OrderedList",
  componentId: "i5y035-1"
})(["", ";"], olStyle);
exports.OrderedList = OrderedList;
var liStyle = (0, _styledComponents.css)(["position:relative;-webkit-column-break-inside:avoid;break-inside:avoid;color:", ";padding:", ";page-break-inside:avoid;width:100%;ul,ol{padding-top:", ";}", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.li.color;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.typography.li.padding;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.md;
}, function (_ref16) {
  var size = _ref16.size,
    _ref16$theme = _ref16.theme,
    typography = _ref16$theme.typography,
    breakpoints = _ref16$theme.breakpoints;
  var _getParagraphSize = (0, _globals.getParagraphSize)(typography.li, size),
    min = _getParagraphSize.min,
    max = _getParagraphSize.max;
  return (0, _styledComponents.css)(["", " margin:0;"], (0, _globals.getFontStyle)(typography['li'], breakpoints.sm, min, max));
});
exports.liStyle = liStyle;
var Li = _styledComponents.default.li.withConfig({
  displayName: "Liststyle__Li",
  componentId: "i5y035-2"
})(["", ";"], liStyle);
exports.Li = Li;